import * as FlatModels from '@medsurf/flat-models';
import * as EntityBaseActions from '../base/entity.base.actions';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetEntitySuccess = '[STORE | ENTITY | POINT_OF_INTEREST] Get Entity Success',
  GetEntitiesSuccess = '[STORE | ENTITY | POINT_OF_INTEREST] Get Entities Success',
  ModifyEntitySuccess = '[STORE | ENTITY | POINT_OF_INTEREST] Modify Entity Success',
  ModifyEntitiesSuccess = '[STORE | ENTITY | POINT_OF_INTEREST] Modify Entities Success',
  AddEntity = '[STORE | ENTITY | POINT_OF_INTEREST] Add Entity',
  UpdateEntity = '[STORE | ENTITY | POINT_OF_INTEREST] Update Entity',
  RemoveEntity = '[STORE | ENTITY | POINT_OF_INTEREST] Remove Entity',
  UndoSnapshot = '[STORE | ENTITY | POINT_OF_INTEREST] Undo Snapshot',
  RedoSnapshot = '[STORE | ENTITY | POINT_OF_INTEREST] Redo Snapshot',
  CleanUpSnapshots = '[STORE | ENTITY | POINT_OF_INTEREST] Clean Up Snapshots',
  SetPoiId = '[STORE | ENTITY | POINT_OF_INTEREST] Set Poi Id',
  RearrangePois = '[STORE | ENTITY | POINT_OF_INTEREST] Rearrange Pois',
  RearrangeImagePois = '[STORE | ENTITY | POINT_OF_INTEREST] Rearrange Image Pois',
  RearrangePoiAnnotations = '[STORE | ENTITY | POINT_OF_INTEREST] Rearrange Poi Annotations',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Entity Success
 */
export class GetEntitySuccess extends EntityBaseActions.GetEntitySuccess {
  public static readonly type = ActionTypes.GetEntitySuccess;
}

/**
 * Get Entities Success
 */
export class GetEntitiesSuccess extends EntityBaseActions.GetEntitiesSuccess {
  public static readonly type = ActionTypes.GetEntitiesSuccess;
}

/**
 * Modify Entity Success
 */
export class ModifyEntitySuccess extends EntityBaseActions.ModifyEntitySuccess {
  public static readonly type = ActionTypes.ModifyEntitySuccess;
}

/**
 * Modify Entities Success
 */
export class ModifyEntitiesSuccess extends EntityBaseActions.ModifyEntitiesSuccess {
  public static readonly type = ActionTypes.ModifyEntitiesSuccess;
}

/**
 * Add Entity
 */
export class AddEntity extends EntityBaseActions.AddEntity<FlatModels.PointOfInterestEntityModels.PointOfInterest> {
  public static readonly type = ActionTypes.AddEntity;
}

/**
 * Update Entity
 */
export class UpdateEntity extends EntityBaseActions.UpdateEntity<FlatModels.PointOfInterestEntityModels.PointOfInterest> {
  public static readonly type = ActionTypes.UpdateEntity;
}

/**
 * Remove Entity
 */
export class RemoveEntity extends EntityBaseActions.RemoveEntity<FlatModels.PointOfInterestEntityModels.PointOfInterest> {
  public static readonly type = ActionTypes.RemoveEntity;
}

/**
 * Undo Snapshot
 */
export class UndoSnapshot extends EntityBaseActions.UndoSnapshot {
  public static readonly type = ActionTypes.UndoSnapshot;
}

/**
 * Redo Snapshot
 */
export class RedoSnapshot extends EntityBaseActions.RedoSnapshot {
  public static readonly type = ActionTypes.RedoSnapshot;
}

/**
 * Clean Up Snapshots
 */
export class CleanUpSnapshots extends EntityBaseActions.CleanUpSnapshots {
  public static readonly type = ActionTypes.CleanUpSnapshots;
}

/**
 * Set Poi Id
 */
export class SetPoiId {
  public static readonly type = ActionTypes.SetPoiId;

  public constructor(public poiId: string | null) {
  }
}

/**
 * Rearrange Pois
 */
export class RearrangePois {
  public static readonly type = ActionTypes.RearrangePois;
  
  public constructor(public pois: FlatModels.PointOfInterestEntityModels.PointOfInterest[] | string[]) {
  }
}

/**
 * Rearrange Image Pois
 */
export class RearrangeImagePois {
  public static readonly type = ActionTypes.RearrangeImagePois;
  
  public constructor(public image: FlatModels.ImageEntityModels.Image,
                     public pois: FlatModels.PointOfInterestEntityModels.PointOfInterest[] | string[]) {
  }
}

/**
 * Rearrange Poi Annotations
 */
export class RearrangePoiAnnotations {
  public static readonly type = ActionTypes.RearrangePoiAnnotations;
  
  public constructor(public poi: FlatModels.PointOfInterestEntityModels.PointOfInterest,
                     public annotationToPointOfInterests: FlatModels.PointOfInterestEntityModels.AnnotationToPointOfInterest[]) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>